import { queryClient } from "~/plugins/vue-query";
import { projectService } from "~/utils/api/projectService";
import { contactService } from "~/utils/api/contactService";

export default defineNuxtRouteMiddleware(async () => {
  queryClient.fetchQuery({
    queryKey: ["projects"],
    queryFn: () =>
      projectService.getProject({
        with: ["advisor", "engineer", "project"],
      }),
  });
  queryClient.fetchQuery({
    queryKey: ["contact-data"],
    queryFn: () =>
      contactService.getContanctData({
        with: ["settings"],
      }),
  });
});
